export default {
    searchTerm: '',
    useApiValoAuth: window.config.use_apivalo_auth,
};



// WEBPACK FOOTER //
// ./src/store/state.js